import React, { useContext } from 'react'
import { useTheme } from '@emotion/react'
import AppContext from 'context/app'
import useNavHeight from 'hooks/useNavHeight'
import Container from 'components/container.js'
import NavSearchResults from 'components/search/results.js'
import NavProducts from './products'
import NavAccount from './account'
import { motion, AnimatePresence } from "motion/react"

export const Overlays = (name, isMobile) => {
    switch(name){
        case 'Search':
            return <NavSearchResults isMobile={isMobile} />
        case 'Products':
            return <NavProducts isMobile={isMobile} />
        case 'Account':
            return <NavAccount isMobile={isMobile} />
        default:
            return null
    }
}

export default function NavOverlay() {
    const { overlay, closeOverlay } = useContext(AppContext)
    const height = useNavHeight()
    const theme = useTheme()

    return (
        // https://motion.dev/docs/react-animate-presence
        <AnimatePresence>
            {/* https://motion.dev/docs/react-motion-component */}
            {(overlay && overlay !== 'Mobile') && <motion.div
                // https://motion.dev/docs/react-transitions
                transition={{ duration: .3 }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <Container fluid
                    id='nav-overlay'
                    className='d-flex f-column p-absolute top-100 left-0 z-nav'
                    style={{ height: `calc(100vh - ${height}px)` }}
                >
                    <Container fluid
                        id='main-overlay-background'
                        css={{ borderTop: `0.5px solid ${theme.colors.black}` }}
                    >
                        <Container
                            id='main-overlay'
                            style={{
                                maxHeight: `calc(100vh - ${height}px)`,
                                overflowY: 'auto',
                            }}
                        >
                            <div css={{ padding: '32px 32px 40px' }}>
                                <AnimatePresence mode='wait'>
                                    <motion.div
                                        key={overlay}
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: .2 }}
                                    >
                                        {Overlays(overlay, false)}
                                    </motion.div>
                                </AnimatePresence>
                            </div>
                        </Container>
                    </Container>
                    <div
                        onClick={closeOverlay}
                        className='grow-1'
                        css={{
                            background: 'rgba(0, 0, 0, 0.33)',
                            backdropFilter: 'blur(30px)',
                        }}
                    />
                </Container>
            </motion.div>}
        </AnimatePresence>
    )
}
